import http from "@/backend/http.js";

async function getExchangeEntries() {
  try {
    const response = await http.get(`json-dialer/entries`);

    return response.data.map((x) => {
      return {
        id: x.id,
        dataType: x.dataType,
        updatedAt: x.updatedAt,
        data: x.data,
      };
    });
  } catch (err) {
    throw err;
  }
}

export { getExchangeEntries };
